import { SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { Leaf, Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { NotificationBell } from "@/components/NotificationBell";
import { Footer } from "@/components/Footer";

const HIDE_FOOTER_ROUTES = ["/assistente"];

interface AppLayoutProps {
  children: React.ReactNode;
}

function HeaderContent() {
  const { toggleSidebar } = useSidebar();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center justify-between gap-3 px-4">
        <div className="flex items-center gap-2 min-w-0">
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={toggleSidebar}
            className="h-10 w-10 flex-shrink-0"
          >
            <Menu className="h-5 w-5" />
            <span className="sr-only">Menu</span>
          </Button>
          <Link 
            to="/" 
            className="flex items-center gap-2 min-w-0 flex-1"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary hover:bg-primary/90 transition-colors flex-shrink-0">
              <Leaf className="h-5 w-5 text-primary-foreground" />
            </div>
            <span className="font-display font-bold text-foreground text-sm sm:text-base md:text-lg leading-tight">
              Guia Essencial
            </span>
          </Link>
        </div>

        <div className="flex items-center gap-1">
          <NotificationBell />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
export function AppLayout({ children }: AppLayoutProps) {
  const { pathname } = useLocation();
  const hideFooter = HIDE_FOOTER_ROUTES.includes(pathname);

  return (
    <SidebarProvider defaultOpen={false}>
      <div className="flex min-h-screen w-full overflow-x-hidden">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0 h-screen overflow-y-auto">
          <HeaderContent />
          <main className="flex-1 flex flex-col">
            {children}
          </main>
          {!hideFooter && <Footer />}
        </div>
      </div>
    </SidebarProvider>
  );
}
